import { createStyles } from "@mantine/core";

export const useServicePlanStyles = createStyles((theme) => ({
  servicePlanContainer: {
    width: "100%",
    paddingBlock: "20px",
  },

  stepper: {
    "& .mantine-Stepper-step": {
      backgroundColor: "#FFFFFF",
      cursor: "pointer",
    },
    "& .mantine-Stepper-stepIcon": {
      backgroundColor: "#F5F5F5",
      border: "2px solid #E5E5E5",
      color: "#737373",
      "&[data-completed]": {
        backgroundColor: "#F59E0B",
        borderColor: "#F59E0B",
        color: "#FFFFFF",
      },
      "&[data-progress]": {
        backgroundColor: "#F59E0B",
        borderColor: "#F59E0B",
        color: "#FFFFFF",
      },
    },
    "& .mantine-Stepper-stepLabel": {
      fontFamily: "Inter, sans-serif",
      fontWeight: 600,
      fontSize: "14px",
      color: "#262626",
    },
    "& .mantine-Stepper-stepDescription": {
      fontFamily: "Inter, sans-serif",
      fontSize: "12px",
      color: "#737373",
    },
  },

  stepContent: {
    marginTop: "30px",
    minHeight: "400px",
  },

  navigationButtons: {
    paddingTop: "20px",
    borderTop: "1px solid #E5E5E5",
    marginTop: "30px",
  },

  formSection: {
    marginBottom: "24px",
  },

  sectionTitle: {
    fontFamily: "Inter, sans-serif",
    fontSize: "18px",
    fontWeight: 600,
    color: "#262626",
    marginBottom: "16px",
  },

  accordion: {
    "& .mantine-Accordion-control": {
      backgroundColor: "#F4F3FF",
      borderTopLeftRadius: "12px",
      borderTopRightRadius: "12px",
      borderBottom: "1px solid #D9D9D9",
      padding: "16px 20px",
      fontFamily: "Inter, sans-serif",
      fontWeight: 500,
      fontSize: "16px",
      color: "#262626",
      "&:hover": {
        backgroundColor: "#EEE9FF",
      },
    },
    "& .mantine-Accordion-content": {
      backgroundColor: "#FFFFFF",
      borderBottomLeftRadius: "12px",
      borderBottomRightRadius: "12px",
      padding: "20px",
    },
    "& .mantine-Accordion-item": {
      border: "1px solid #D9D9D9",
      borderRadius: "12px",
      marginBottom: "12px",
      overflow: "hidden",
    },
    "& .mantine-Accordion-chevron": {
      color: "#737373",
    },
  },

  checkboxGroup: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
  },

  checkboxItem: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
  },

  checkboxAndLabelStyle: {
    "& .mantine-Checkbox-body": {
      alignItems: "center",
    },
    "& .mantine-Checkbox-label": {
      backgroundColor: "#F2F4F7",
      color: "#525252",
      padding: "5px 10px",
      borderRadius: "16px",
      marginLeft: "8px",
      fontFamily: "Inter",
      fontSize: "12px",
      fontWeight: 500,
      cursor: "pointer",
    },
    "& svg": {
      color: "#404040 !important",
    },
    "& input": {
      borderRadius: 6,
      cursor: "pointer",
    },
    "& input:checked": {
      backgroundColor: "#FAFAFA",
      borderColor: "#404040",
    },
  },

  textInput: {
    marginLeft: "28px",
    "& input": {
      backgroundColor: "#FFFFFF",
      border: "1px solid #E5E5E5",
      borderRadius: "8px",
      boxShadow: "0 1px 2px 0 rgba(16, 24, 40, 0.05)",
      fontFamily: "Inter",
      fontSize: "14px",
      fontWeight: 400,
      color: "#525252",
      "&:focus": {
        borderColor: "#404040",
      },
    },
  },

  subCheckboxItem: {
    marginLeft: "30px",
  },

  emergencyContact: {
    backgroundColor: "#F9FAFB",
    padding: "16px",
    borderRadius: "8px",
    border: "1px solid #E5E5E5",
  },

  signatureBox: {
    border: "2px dashed #D1D5DB",
    borderRadius: "8px",
    padding: "24px",
    textAlign: "center",
    cursor: "pointer",
    transition: "all 0.2s ease",
    backgroundColor: "#FFFFFF",
    "&:hover": {
      borderColor: "#F59E0B",
      backgroundColor: "#FFFBEB",
    },
  },

  signatureCanvas: {
    border: "1px solid #E5E5E5",
    borderRadius: "8px",
    cursor: "crosshair",
  },

  fieldGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
    gap: "16px",
  },

  dateRangePicker: {
    "& .mantine-DateRangePicker-input": {
      backgroundColor: "#F9FAFB",
      border: "1px solid #E5E5E5",
      borderRadius: "8px",
      fontFamily: "Inter, sans-serif",
    },
  },

  select: {
    "& .mantine-Select-input": {
      backgroundColor: "#F9FAFB",
      border: "1px solid #E5E5E5",
      borderRadius: "8px",
      fontFamily: "Inter, sans-serif",
      fontSize: "14px",
    },
  },

  input: {
    "& input, & textarea": {
      backgroundColor: "#F9FAFB",
      border: "1px solid #E5E5E5",
      borderRadius: "8px",
      fontFamily: "Inter, sans-serif",
      fontSize: "14px",
      "&:focus": {
        borderColor: "#F59E0B",
        backgroundColor: "#FFFFFF",
      },
    },
  },

  multiSelect: {
    "& .mantine-MultiSelect-input": {
      backgroundColor: "#F9FAFB",
      border: "1px solid #E5E5E5",
      borderRadius: "8px",
      fontFamily: "Inter, sans-serif",
      minHeight: "42px",
    },
    "& .mantine-MultiSelect-value": {
      backgroundColor: "#FFF6ED",
      color: "#C4320A",
      borderRadius: "16px",
    },
  },

  clientDataContent: {
    display: "flex",
    flexDirection: "column",
    gap: 12,
  },
  accordionStyle: {
    "& .mantine-Accordion-chevron": {
      transition: "transform 200ms ease",
      "& svg": {
        fontSize: 34,
        color: "#000",
      },
      "&[data-active]": {
        transform: "rotate(180deg)",
      },
    },
    "& .mantine-Accordion-item": {
      backgroundColor: "#FFF",
      border: "1px solid #E5E5EA",
      borderRadius: 12,
    },
    "& .mantine-Accordion-control": {
      "& .display-on-close": {
        display: "none !important",
      },
      '&[aria-expanded="false"]': {
        "& .display-on-close": {
          display: "block !important",
        },
      },
      '&[aria-expanded="true"] .display-on-close': {
        display: "none !important",
      },
      "& .mantine-Accordion-label": {
        fontSize: 16,
        fontWeight: 500,
        color: "#262626",
        fontFamily: "Inter",
      },
    },
    "& .mantine-Accordion-content": {
      padding: "24px 13px",
      borderTop: "1px solid #E5E5E5",
    },
    // "& .mantine-Accordion-item:last-child": {
    //   borderBottom: "none",
    // },
  },
  fieldsAccordion: {
    "& .mantine-Accordion-item": {
      backgroundColor: "#FFF",
      border: "1px solid #D9D9D9",
      borderRadius: 10,
    },
    "& .mantine-Accordion-chevron": {
      transition: "transform 200ms ease",
      "& svg": {
        fontSize: 24,
        color: "#94A3B8",
      },
      "&[data-active]": {
        transform: "rotate(180deg)",
      },
    },
    "& .mantine-Accordion-control": {
      backgroundColor: "#F4F3FF",
      borderTopLeftRadius: 10,
      borderTopRightRadius: 10,
      "& .display-on-close": {
        display: "none !important",
      },
      '&[aria-expanded="false"]': {
        borderRadius: 10,
        "& .display-on-close": {
          display: "block !important",
        },
      },
      '&[aria-expanded="true"] .display-on-close': {
        display: "none !important",
      },
      "& .mantine-Accordion-label": {
        fontSize: 14,
        fontWeight: 600,
        color: "#000",
        fontFamily: "Inter",
        paddingBlock: 10,
      },
    },
    "& .mantine-Accordion-content": {
      padding: "11px 9px",
      borderTop: "1px solid #D9D9D9",
    },
  },

  inputStyle: {
    "& .mantine-Input-wrapper": {
      height: "auto",
      backgroundColor: "#FFFFFF",
      borderRadius: "8px",
      border: "1px solid #E5E5E5",
      boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
      "& .mantine-Input-input": {
        fontFamily: "Inter",
        border: "none",
        backgroundColor: "transparent",
        padding: "10px 14px",
        height: "44px",
        fontFamily: "Inter",
        color: "#262626",
      },
      "& .mantine-Textarea-input": {
        height: 153,
        overflowY: "auto",
      },
      "& .mantine-Select-rightSection svg": {
        color: "#667085",
      },
    },
    "& .mantine-DateInput-wrapper": {
      outline: "4px solid rgb(212, 212, 212, .2)",
      "& .mantine-DateInput-icon": {
        "& svg": {
          color: "#262626",
          fontSize: 18,
        },
      },
      "& .mantine-DateInput-input": {
        paddingLeft: 36,
        fontWeight: 600,
      },
    },
    "& .mantine-InputWrapper-label": {
      color: "#262626",
      marginBottom: "6px",
      fontFamily: "Inter",
      fontSize: "14px",
      fontWeight: 500,
    },
  },
  diagnosisBoxLabel: {
    color: "#262626",
    fontFamily: "Inter",
    fontSize: "14px",
    fontWeight: 500,
    alignItems: "center",
    gap: 12,
    marginBottom: 6,
  },
  diagnosisBox: {
    borderRadius: 8,
    border: "1px solid #E5E5E5",
    backgroundColor: "#FFF",
    boxShadow: "0 1px 2px 0 rgba(16, 24, 40, 0.05)",
    padding: "10px 14px",
    height: 153,
    overflowY: "auto",
  },
  diagnosisBoxItemsFlex: {
    gap: "12px",
    flexWrap: "wrap",
  },
  diagnosisBoxItem: {
    alignItems: "center",
    gap: 4,
    padding: "4px 10px",
    height: "fit-content",
    width: "fit-content",
    borderRadius: 16,
    backgroundColor: "#F2F4F7",
    "& p": {
      margin: 0,
      whiteSpace: "nowrap",
      fontFamily: "Inter",
      fontSize: 14,
      fontWeight: 500,
      color: "#344054",
    },
    "& svg": {
      fontSize: 24,
      color: "#667085",
    },
  },
  signRow: {
    alignItems: "flex-end",
    gap: 10,
  },
  signatureInfoRow: {
    alignItems: "flex-end",
    width: "85%",
    gap: 10,
    marginInline: "auto",
    marginBottom: 50,
  },
  btnStyle: {
    padding: "0px 20px",
    borderRadius: "8px",
    border: "1px solid #FFAF4A",
    backgroundColor: "#FFAF4A",
    height: 44,
    boxShadow: "0 1px 2px 0 rgba(16, 24, 40, 0.05)",
    fontSize: 16,
    fontWeight: 600,
    fontFamily: "Inter",
    color: "#262626",
    "& .mantine-Button-label": {
      gap: 8,
    },
    ":hover": {
      backgroundColor: "#FFAF4A",
      opacity: 0.8,
    },
  },
  signBtn: {
    fontSize: 14,
    height: 40,
    padding: "0px 16px",
  },
  greenBtnStyle: {
    backgroundColor: "#00A63E",
    borderColor: "#00A63E",
    fontSize: 14,
    fontWeight: 500,
    color: "#FFF",
    ":hover": {
      backgroundColor: "#00A63E",
      opacity: 0.8,
    },
  },
  requestSignatureBtn: {
    border: "1px solid #FEF3F2",
    backgroundColor: "#FEF3F2",
    fontSize: 14,
    color: "#DC2626",
    "& .mantine-Button-label svg": {
      color: "#DC2626",
    },
    ":hover": {
      backgroundColor: "#FEF3F2",
      opacity: 0.8,
    },
    "&:disabled": {
      "& .mantine-Button-label svg": {
        color: "#adb5bd",
      },
    },
  },
  cancelBtn: {
    padding: "12px 20px",
    borderRadius: "8px",
    border: "1px solid #D0D5DD",
    backgroundColor: "#F9FAFB",
    height: 44,
    boxShadow: "0 1px 2px 0 rgba(16, 24, 40, 0.05)",
    fontSize: 16,
    fontWeight: 600,
    fontFamily: "Inter",
    color: "#262626",
    ":hover": {
      backgroundColor: "#F9FAFB",
      opacity: 0.8,
    },
  },
  inputFlex: {
    flex: 1,
  },
  sectionHdng: {
    fontSize: 24,
    fontWeight: 700,
    fontFamily: "Inter",
    color: "#000",
    margin: 0,
    padding: "0px 10px 5px 10px",
    marginBottom: 20,
    borderBottom: "1px solid #D9D9D9",
  },
  signatureRequestCard: {
    maxWidth: 600,
    marginInline: "auto",
    backgroundColor: "#FFF",
    borderRadius: 12,
    outline: "0.50px #E5E5E5 solid",
    outlineOffset: "-0.50px",
    boxShadow:
      "0px 8px 8px -4px rgba(16, 24, 40, 0.03), 0px 20px 24px -4px rgba(16, 24, 40, 0.08)",
    // boxShadow:
    //   "0 20px 24px -4px rgba(16, 24, 40, 0.08), 0 8px 8px -4px rgba(16, 24, 40, 0.03)",
    padding: "23px 4px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    "& .warningIcon": {
      border: "8px solid #FEE4E2",
      backgroundColor: "#FECDCA",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      height: 50,
      width: 50,
      borderRadius: "50%",
      marginBottom: 14,
      "& svg": {
        fontSize: 18,
        color: "#D92D20",
      },
    },
    "& .cardHdng": {
      fontSize: 18,
      fontWeight: 600,
      fontFamily: "Inter",
      color: "#262626",
      margin: 0,
    },
    "& .cardDiscription": {
      fontSize: 14,
      fontWeight: 400,
      fontFamily: "Inter",
      color: "#737373",
      textAlign: "center",
      margin: 0,
      marginTop: 4,
    },
    "& .imgAndFieldParent": {
      alignItems: "flex-end",
      width: "80%",
      marginTop: 20,
      marginBottom: 10,
      gap: 10,
      "& > img": {
        height: 60,
      },
    },
  },
  btnsRow: {
    width: "90%",
    gap: 12,
  },
  requestSignBtn: {
    padding: "10px 18px",
    borderRadius: "8px",
    border: "1px solid #FEF3F2",
    backgroundColor: "#FEF3F2",
    height: 44,
    boxShadow: "0 1px 2px 0 rgba(16, 24, 40, 0.05)",
    fontSize: 16,
    fontWeight: 600,
    fontFamily: "Inter",
    color: "#B42318",
    ":hover": {
      backgroundColor: "#FEF3F2",
      opacity: 0.8,
    },
  },
  greenSignBtn: {
    padding: "0px 20px",
    borderColor: "#D9F2EF",
    backgroundColor: "#D9F2EF",
    fontSize: 14,
    fontWeight: 500,
    color: "#16A34A",
    ":hover": {
      backgroundColor: "#D9F2EF",
      opacity: 0.8,
    },
  },
  cancelReqSignBtn: {
    padding: "10px 18px",
    borderRadius: "8px",
    border: "1px solid #D0D5DD",
    backgroundColor: "#FFF",
    height: 44,
    boxShadow: "0 1px 2px 0 rgba(16, 24, 40, 0.05)",
    fontSize: 16,
    fontWeight: 600,
    fontFamily: "Inter",
    color: "#262626",
    flex: 1,
    ":hover": {
      backgroundColor: "#FFF",
      opacity: 0.8,
    },
  },
  addSignatureContent: {
    display: "flex",
    flexDirection: "column",
    gap: 20,
    alignItems: "center",
    width: "fit-content",
    marginInline: "auto",
  },
  createSignatureContent: {
    display: "flex",
    flexDirection: "column",
    width: 620,
    marginInline: "auto",
    gap: 20,
    alignItems: "flex-end",
  },
  signatureAndInitialsWrapper: {
    alignItems: "center",
    flexWrap:"wrap",
    gap: 20,
    padding: "5px 15px 10px 15px",
    borderRadius: 10,
    border: "1px solid #E5E5E5",
    width: "fit-content",
    "& .userNameHdng": {
      margin: 0,
      fontSize: 16,
      fontWeight: 700,
      fontFamily: "Inter",
      color: "#000",
      marginBottom: 3,
    },
  },
  signatureAndInitialsRow: {
    display: "flex",
    flexWrap: "wrap",
    borderRadius: 8,
    backgroundColor: "#F5F5F5",
    padding: "12px 15px 16px 15px",
    gap: 18,
  },
  signAndInitialLabel: {
    color: "#262626",
    margin: 0,
    marginBottom: "6px",
    fontFamily: "Inter",
    fontSize: "14px",
    fontWeight: 500,
  },
  signatureAndInitialsBox: {
    borderRadius: 8,
    backgroundColor: "#FFF",
    boxShadow: "0 1px 2px rgba(16, 24, 40, 0.05)",
    width: 190,
    maxWidth: 190,
    height: 44,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    overflow: "hidden",
  },
  textSignatureStyle: {
    fontSize: 28,
    fontWeight: 400,
    fontFamily: "Island Moments",
    color: "#171717",
    margin: 0,
  },
  signatureDrawImg: {
    width: "90%",
  },
  signatureImg: {
    width: "100%",
    objectFit: "cover",
    objectPosition: "center",
  },
  tabs: {
    width: "100%",
    fontFamily: "Inter",
  },
  tab_list: {
    background: "#EAECF0",
    borderRadius: "8px 8px 0px 0px",
    border: "none",
    justifyContent: "center",
  },
  tab: {
    color: "#979797 !important",
    fontFamily: "Inter",
    fontSize: 14,
    marginBottom: 0,
    padding: "20.2px 16px 20.2px 10px",
    fontWeight: 500,
    borderWidth: "2px !important",
    "& > span": {
      display: "flex",
      alignItems: "center",
      gap: 10,
    },
    "&:hover": {
      color: "#27272A !important",
      background: "transparent",
    },
    "&[data-active]": {
      color: "#27272A !important",
      borderColor: "#27272A",
      "&:hover": {
        borderColor: "#27272A",
      },
    },
  },

  signaturePadParent: {
    position: "relative",
    width: "100%",
    display: "inline-block",
    "& canvas": {
      border: "0.5px solid #CBD5E1",
      background: "#fff",
      cursor: "crosshair",
    },
  },
  textPad: {
    height: 160,
    backgroundColor: "#FFF",
    border: "0.5px solid #CBD5E1",
    padding: 10,
    "& input": {
      fontFamily: "'Island Moments', cursive",
      fontSize: 64,
      height: "unset",
      fontWeight: 400,
      color: "#344054",
      textAlign: "center",
    },
  },
  uploadBox: {
    height: 160,
    width: "100%",
    border: "0.5px solid #CBD5E1",
    backgroundColor: "#FFF",
    padding: "0px",
    "& .uploadBoxInner": {
      height: "100%",
      width: "100%",
    },
  },
  previewBox: {
    padding: 10,
    minHeight: 160,
    width: "100%",
    border: "0.5px solid #CBD5E1",
    backgroundColor: "#FFF",
  },
  previewImg: {
    display: "block",
    objectFit: "contain",
    maxHeight: 200,
    width: "auto",
    margin: "auto",
  },
  selectedImgClose: {
    position: "absolute",
    top: 6,
    right: 6,
    borderRadius: "50%",
    backgroundColor: "#27272A",
    paddingLeft: 1,
    paddingBottom: 0.5,
  },
  signRequestStatus: {
    padding: "10px 16px",
    borderRadius: 8,
    boxShadow: "0 1px 2px 0 rgba(16, 24, 40, 0.05)",
    fontSize: 14,
    fontWeight: 600,
    fontFamily: "Inter",
    "&.pending": {
      border: "1px solid #FEF3F2",
      backgroundColor: "#FEF3F2",
      color: "#323E48",
    },
    "&.success": {
      border: "1px solid #FEF3F2",
      backgroundColor: "#E6F6F4",
      color: "#00A991",
    },
  },
  voidSignReqBtn: {
    fontSize: 14,
    fontWeight: 600,
    fontFamily: "Inter",
    color: "#323E48",
    textDecoration: "underline",
  },
  inc_dec_Btn: {
    borderRadius: "50%",
    height: "26px",
    width: "26px",
    backgroundColor: "#FFF",
    filter: "drop-shadow(0px 0px 4px rgba(0, 0, 0, 0.25))",
    padding: "0px",
  },
  requestedSignaturesEmails: {
    flexWrap: "wrap",
    gap: 10,
    alignItems: "center",
    width: "80%",
    justifyContent: "center",
  },
  sendReqSignBtn: {
    maxWidth: "50%",
    width: "100%",
    minWidth: "fit-content",
    marginTop: 25,
  },
  emailAndBtnTag: {
    alignItems: "center",
    backgroundColor: "#F2F4F7",
    borderRadius: 16,
    gap: 4,
    padding: "4px 10px",
    "& > p": {
      fontSize: 14,
      fontWeight: 500,
      fontFamily: "Inter",
      color: "#344054",
      margin: 0,
    },
    "& svg": {
      color: "#667085",
    }
  },
   fullWidthAccordion:{
    width: "100%",
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    gap: 16,
  },
  signaturesProgressText:{
    fontSize: 16,
    fontWeight: 500,
    fontFamily: "Inter",
    color: "#000",
    margin: 0,
    marginTop: 10,
  }
}));
